export default __webpack_public_path__ + "static/media/community.a63cac08.jpeg";